<!-- ── Toolbar: search + new ─────────────────────────────────────────────── -->
<div class="list-tags__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'common.search' | translate"
    class="list-tags__search">
  </ui-form-field>
  <div class="list-tags__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'product', action: 'create' }"
      type="primary"
      icon="plus-cc"
      iconSize="large"
      [label]="'Labels.new_label' | translate"
      (click)="openTag()">
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-tags__table" [class.list-tags__table--with-bulk-bar]="selection.hasSelection">
  <div class="list-tags__table-scroll">

    <!-- Header -->
    <div class="list-tags__table-header">
      <div class="list-tags__table-cell list-tags__table-cell--checkbox" (click)="$event.stopPropagation()">
        <ui-checkbox
          [checked]="selection.isAllSelected"
          [indeterminate]="selection.isPartialSelected"
          [ariaLabel]="'common.select_all' | translate"
          (changed)="selection.toggleAll($event.checked)">
        </ui-checkbox>
      </div>
      <div class="list-tags__table-cell">{{ 'Labels.label_color' | translate }}</div>
      <div class="list-tags__table-cell">{{ 'common.name' | translate }}</div>
      <div class="list-tags__table-cell">{{ 'common.description' | translate }}</div>
      <div class="list-tags__table-cell">{{ 'common.total_products' | translate }}</div>
    </div>

    <!-- Loading state -->
    <div class="list-tags__loading" *ngIf="isAppLoading$ | async">
      <div class="list-tags__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(isAppLoading$ | async) && (tags$ | async) as tags">
      <ng-container *ngIf="tags.length > 0">
        <div *ngFor="let tag of tags"
          class="list-tags__table-row"
          (click)="openTag(tag)">
          <div class="list-tags__table-cell list-tags__table-cell--checkbox" (click)="$event.stopPropagation()">
            <ui-checkbox
              [checked]="selection.isSelected(tag.id)"
              [ariaLabel]="tag.name"
              (changed)="selection.toggleOne(tag.id, $event.checked, $event)">
            </ui-checkbox>
          </div>
          <div class="list-tags__table-cell">
            <span class="list-tags__color-swatch"
              [style.background]="tag.color || '#d1d1d1'"></span>
          </div>
          <div class="list-tags__table-cell list-tags__table-cell--strong">{{ tag.name }}</div>
          <div class="list-tags__table-cell list-tags__table-cell--description">{{ tag?.description || '--' }}</div>
          <div class="list-tags__table-cell">{{ tag.total_products ?? 0 }}</div>
        </div>
      </ng-container>

      <!-- Empty state -->
      <div *ngIf="tags.length === 0" class="list-tags__empty">
        <ng-container *ngIf="!key">
          <img class="list-tags__empty-illustration" src="assets/icones/no-tags.svg" alt="">
          <h3>{{ 'Labels.no_labels' | translate }}</h3>
        </ng-container>
        <ng-container *ngIf="key">
          <img class="list-tags__empty-illustration" src="assets/icones/no-result-search.svg" alt="">
          <h3>{{ 'Labels.no_data_search' | translate }}</h3>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!-- ─────────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ─────────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()">
    <button
      *appHasPermission="{ module: 'product', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()">
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination *ngIf="((tags$ | async)?.length ?? 0) > 0"
    class="list-tags__pagination"
    [pagination]="pagination$ | async"
    (toPageEvent)="toPage($event)">
  </app-pagination>
</div>
